import clsx from 'clsx'
import React, { ComponentPropsWithRef } from 'react'

import styles from './ProductTileWrapper.module.scss'

export const ProductTileWrapper = ({
  children,
  className,
  maxColumns = 4,
  style,
  visibleRows,
  ...props
}: ComponentPropsWithRef<'div'> & {
  maxColumns?: 4 | 8
  visibleRows?: number
}) => (
  <div
    className={clsx(
      styles.productTileWrapper,
      maxColumns === 4 && styles.maxFour,
      maxColumns === 8 && styles.maxEight,
      visibleRows && styles.visibleRows,
      className,
    )}
    style={{
      ...style,
      '--visible-rows': visibleRows,
    } as React.CSSProperties}
    {...props}
  >
    {children}
  </div>
)
